import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import { LoadingOverlay } from '@mantine/core'
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5'

const PdfPreview = ({ file }) => {
  const containerRef = useRef(null)
  const pages = useRef(1)
  const [width, setWidth] = useState(window.innerWidth)
  const [pageList, setPageList] = useState([1])

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    pages.current = numPages
  }, [])

  const onRenderSuccess = (page) => {
    if (page < pages.current && !pageList.includes(page + 1)) {
      setPageList((pre) => pre.concat([page + 1]))
    }
  }

  useEffect(() => {
    if (!containerRef.current) return

    setWidth(containerRef.current.clientWidth)
  }, [])
  return (
    <div ref={containerRef} className="w-full flex-1 overflow-y-auto">
      <Document
        file={file}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<LoadingOverlay visible />}
      >
        {pageList.map((p) => (
          <Page
            key={p}
            width={width}
            pageNumber={p}
            renderTextLayer={false}
            loading={<LoadingOverlay visible />}
            onRenderSuccess={() => onRenderSuccess(p)}
          />
        ))}
      </Document>
    </div>
  )
}

export default memo(PdfPreview)
